import { client_id, scope } from './config.json';

let showDialog = false;

const setAccessToken = (_accessToken) => {
  accessToken = _accessToken;
  localStorage.setItem('accessToken', accessToken || '');
};

const accessTokenFromUrlHash = getTokenFromUrlHash();
if (accessTokenFromUrlHash) global.location.hash = '';

let accessToken =
  accessTokenFromUrlHash ||
  (getRefreshTokenFromUrlHash() ? null : localStorage.getItem('accessToken'));
const spfetch = (global.spfetch = async (input, init) => {
  if (!accessToken) await spfetch.login();
  if (!init) init = {};
  if (!init.headers) init.headers = {};
  init.headers.Authorization = `Bearer ${accessToken}`;
  const response = await fetch(
    /^https?:\/\//.test(input)
      ? input
      : `https://api.spotify.com${input.startsWith('/') ? '' : '/'}${input}`,
    {
      ...init,
      body:
        typeof init.body === 'object' ? JSON.stringify(init.body) : init.body,
    }
  );

  const { ok, status, statusText } = response;

  let json = {};
  let text;
  try {
    text = await response.text();
    json = JSON.parse(text);
  } catch (error) {}

  const { error: { message: errorMessage } = {} } = json || {};

  if (
    response.status === 401 &&
    (errorMessage === 'The access token expired' ||
      errorMessage === 'Invalid access token' ||
      text === 'Token expired')
  ) {
    setAccessToken(await fetchToken());
    return spfetch(input, init);
  }

  return Object.assign(json, { ok, status });
});

spfetch.login = async () => {
  setAccessToken(accessToken || (await fetchToken()));
  return !!accessToken;
};
spfetch.loginWithRefreshTokenIfAvailable = async () => {
  setAccessToken(await fetchAccessTokenFromRefreshToken());
  return !!accessToken;
};
spfetch.logout = () => {
  setAccessToken('');
  showDialog = true;
};
spfetch.isLoggedIn = () => !!accessToken;
spfetch.getToken = () => accessToken;

export default spfetch;

function getTokenFromUrlHash() {
  return new URLSearchParams(global.location.hash.slice(1)).get('access_token');
}

async function fetchToken() {
  return (
    (await fetchAccessTokenFromRefreshToken()) || (await fetchTokenFromPopup())
  );
}

async function fetchTokenFromPopup() {
  return new Promise((resolve, reject) => {
    const timeout = setTimeout(
      reject,
      20000,
      new Error('Timeout getting token')
    );
    window.addEventListener(
      'message',
      function onMessage(event) {
        let data = event.data;
        try {
          data = JSON.parse(event.data);
        } catch (error) {}
        const { type, accessToken } = data || {};
        if (type === 'access_token') {
          clearTimeout(timeout);
          resolve(accessToken);
          window.removeEventListener('message', onMessage, false);
        }
      },
      false
    );

    const width = 450;
    const height = 730;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;

    let url = new URL(window.location.origin);
    url.pathname =
      window.location.hostname === 'localhost' ? 'auth.html' : 'auth';
    url = new URL('https://spotify-react-app-template.now.sh/auth');
    url.searchParams.set('client_id', client_id);
    url.searchParams.set('scope', scope);
    url.searchParams.set('show_dialog', showDialog);

    const opened = window.open(
      url.toString(),
      'Spotify',
      `menubar=no,location=no,resizable=no,scrollbars=no,status=no, width=${width}, height=${height}, top=${top}, left=${left}`
    );

    if (!opened) {
      localStorage.removeItem('accessToken');
      global.location.reload();
      resolve(null);
    }
  });
}

function getRefreshTokenFromUrlHash() {
  return new URLSearchParams(global.location.hash.slice(1)).get(
    'refresh_token'
  );
}

async function fetchAccessTokenFromRefreshToken() {
  const refreshToken = getRefreshTokenFromUrlHash();
  if (!refreshToken) return false;

  const response = await fetch('/api/token', {
    method: 'POST',
    body: new URLSearchParams({
      grant_type: 'refresh_token',
      refresh_token: refreshToken,
    }).toString(),
    headers: {
      'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
  });

  let json;
  try {
    json = await response.json();
  } catch (error) {}
  if (!response.ok)
    throw new Error(
      (json && json.error_description) ||
        `Failed with status ${response.status}`
    );

  return json && json.access_token;
}
